import createSvgIcon from "@mui/material/utils/createSvgIcon";

export const MtGuideIcon = createSvgIcon(
  <svg viewBox="0 0 178.46 191" stroke="currentColor" fill="currentColor">
    <g>
      <rect
        transform="matrix(1 0 -.17467 .98463 0 0)"
        x="86.153"
        y="133.54"
        width="43.345"
        height="57.079"
        strokeWidth="6.7261"
      />
      <ellipse
        cx="90.114"
        cy="85.319"
        rx="23.707"
        ry="23.707"
        strokeWidth="7.5862"
      />
      <path
        d="m9.514 75s13.972 43.162 25 45l30 5c16.765 2.7942 33.235 7.2058 50 10 30 5 33.333-1.6667 40-15l15-30"
        fillOpacity="0"
        strokeWidth="20"
      />
      <path d="m9.514 15-1e-6 65" strokeWidth="10" />
    </g>
    <path
      d="m9.514 15s16.301-14.984 26.667-15c10.425-0.016553 16.448 15.033 26.873 15 10.307-0.032918 26.461-15 26.461-15v40s-16.301 15-26.667 15-16.301-15-26.667-15-26.667 15-26.667 15v-40"
      strokeWidth="0"
    />
  </svg>,
  "guide"
);
